function cov_av4c6ucfq() {
  var path = "/app/src/hooks/use-style-config.ts";
  var hash = "d6dd29965a0756a056005fda0d48f70bfe74c4f1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/hooks/use-style-config.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 42
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 30
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 32
        }
      },
      "3": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 17,
          column: 27
        }
      },
      "4": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 16,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 30
          },
          end: {
            line: 9,
            column: 31
          }
        },
        loc: {
          start: {
            line: 9,
            column: 36
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 17
          },
          end: {
            line: 12,
            column: 18
          }
        },
        loc: {
          start: {
            line: 12,
            column: 23
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 12
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 10
          },
          end: {
            line: 15,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 10
          },
          end: {
            line: 15,
            column: 28
          }
        }, {
          start: {
            line: 15,
            column: 32
          },
          end: {
            line: 15,
            column: 34
          }
        }],
        line: 15
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d6dd29965a0756a056005fda0d48f70bfe74c4f1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_av4c6ucfq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_av4c6ucfq();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { useAppContext } from 'src/context/store/app-provider';
var DEFAULT_STYLE_CONFIG = (cov_av4c6ucfq().s[0]++, {
  hasBorder: true
});
cov_av4c6ucfq().s[1]++;
export var useStyleConfig = function useStyleConfig() {
  cov_av4c6ucfq().f[0]++;
  var config = (cov_av4c6ucfq().s[2]++, useAppContext());
  cov_av4c6ucfq().s[3]++;
  return useMemo(function () {
    var _ref;
    cov_av4c6ucfq().f[1]++;
    cov_av4c6ucfq().s[4]++;
    return _objectSpread(_objectSpread({}, DEFAULT_STYLE_CONFIG), (_ref = (cov_av4c6ucfq().b[0][0]++, config.styleConfig)) !== null && _ref !== void 0 ? _ref : (cov_av4c6ucfq().b[0][1]++, {}));
  }, [config.styleConfig]);
};